export type ValueOf<T> = T[keyof T]

export enum Mode {
	Add = 'add',
	Edit = 'edit',
	Readonly = 'readonly',
}
